/**
 * @module interface
 */
export interface V2TimFriendApplication {
    userID: string;
    nickName?: string;
    faceUrl?: string;
    addTime?: number;
    addSource?: string;
    addWording?: string;
    type: number;
}
